import { createContext, useContext, useState, useCallback } from "react";

const EnquiryContext = createContext(null);

export const useEnquiry = () => {
  const ctx = useContext(EnquiryContext);
  if (!ctx) throw new Error("useEnquiry must be used within EnquiryProvider");
  return ctx;
};

export const EnquiryProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState(null);

  const openEnquiry = useCallback((productName) => {
    setProduct(productName || "General Enquiry");
    setOpen(true);
  }, []);

  return (
    <EnquiryContext.Provider value={{ open, setOpen, product, openEnquiry }}>
      {children}
    </EnquiryContext.Provider>
  );
};
